/**
 * Gift line (`_gift` property, added at checkout by the ROC discount app).
 * When its code is no longer applicable (cart below the offer's minimum), the cart sections render
 * the theme's own remove control on that line, marked `data-gift-stale`; this clicks it, so the
 * theme removes the line and refreshes both carts itself. Then the removal notice shows once.
 * theme.js's cart events are private, so this follows the carts' re-render.
 */
(() => {
  const removedFlag = 'roc-gift-removed';
  const containers = '[data-section-type="cart"], [data-section-type="quick-cart"]';
  const clicked = new Set();
  let timer;

  /**
   * @param {boolean | null} on - write when boolean, read when null
   * @returns {boolean}
   */
  const flag = (on = null) => {
    try {
      if (on === true) sessionStorage.setItem(removedFlag, '1');
      if (on === false) sessionStorage.removeItem(removedFlag);
      return sessionStorage.getItem(removedFlag) === '1';
    } catch (error) {
      return false;
    }
  };

  const run = () => {
    const stale = document.querySelector('[data-gift-stale]');
    const key = stale?.closest('[data-key]')?.dataset.key;

    // One click per line per page load: a refused removal must not loop.
    if (stale && key && !clicked.has(key)) {
      clicked.add(key);
      flag(true);
      stale.click();
      return;
    }

    const notices = document.querySelectorAll('[data-gift-removed]');
    if (!flag() || notices.length === 0) return;
    notices.forEach((notice) => {
      notice.hidden = false;
    });
    flag(false);
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  };

  const start = () => {
    const observer = new MutationObserver(schedule);
    document.querySelectorAll(containers).forEach((container) => {
      observer.observe(container, { childList: true, subtree: true });
    });
    run();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
